import Axpi from '../axpi'

const urlPrefix = 'dynamics/sorority-wars/bosses'

const bossesAPI = {
  getAll () {
    return Axpi.$http().get(urlPrefix)
  },
  getRewards (bossId) {
    return Axpi.$http().get(`${urlPrefix}/${bossId}/rewards`)
  },
  attack (bossId, captchaResponse) {
    const data = captchaResponse ? { c3p0: captchaResponse } : {}
    return Axpi.$http().post(`${urlPrefix}/${bossId}/attack`, data)
  },
  claimReward (bossId, rewardId, captchaResponse) {
    const data = captchaResponse ? { c3p0: captchaResponse } : {}
    return Axpi.$http().post(`${urlPrefix}/${bossId}/rewards/${rewardId}/claim`, data)
  }
}

export default bossesAPI
